import { ReactElement, ReactNode } from 'react';

import {
  ApiABExperimentBucketForId,
  ApiABExperimentId,
} from 'api/types/ApiABExperiment';

import { useABExperimentBucket } from './useABExperimentBucket';

type Props<TExperimentId extends ApiABExperimentId> = {
  experimentId: TExperimentId;
  defaultBucket: ApiABExperimentBucketForId<TExperimentId>;
  render: (bucket: ApiABExperimentBucketForId<TExperimentId>) => ReactNode;
  initializeWithDefault?: boolean;
};

export function ABExperiment<TExperimentId extends ApiABExperimentId>({
  experimentId,
  defaultBucket,
  render,
  initializeWithDefault,
}: Props<TExperimentId>): ReactElement | null {
  const bucket = useABExperimentBucket({
    experimentId,
    defaultBucket,
    initializeWithDefault,
  });

  if (!bucket) return null;

  return <>{render(bucket)}</>;
}
